export default "__VITE_ASSET__rpn8xteU__"